import { generatePath } from 'react-router-dom';

import { ROUTES } from 'src/constants';
import { history, t } from 'src/utils';

import { toastStore } from 'stores';

import { copiedLinkStore } from '../stores';

export const handleCreateNew = () => {
  history.push(ROUTES.createSmartLink);
};

export const handleEditLink = (token: string) => {
  const path = generatePath(ROUTES.smartLinkEdit, { token: token });
  history.push(path);
};

export const handleCopyLink = (url: string) => {
  navigator.clipboard.writeText(url);
  copiedLinkStore.set(url);
  toastStore.show(`${t.staticAsString('smartLinks.copiedLink')} ${url}`, null, 4000);
  setTimeout(function () {
    copiedLinkStore.value === url && copiedLinkStore.set('');
  }, 4000);
};
